import { Outlet } from "react-router-dom";
import Layout from "../components/Layout";

/**
 * Free plans use the exact same application chrome as paid plans.
 * Entitlements are handled by route guards, navigation filtering, and the API.
 */
export default function LimitedWorkspaceLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
